export const SIGNIN_OPEN_EVENT = "relayrigs-open-signin";

export const openSignIn = (tab = "signin", role = null) => {
  window.dispatchEvent(new CustomEvent(SIGNIN_OPEN_EVENT, { detail: { tab, role } }));
};
